import { CheckCircle2 } from "lucide-react";
import styles from "./InventoryTakingBalancedBanner.module.scss";

const InventoryTakingBalancedBanner = ({ foundCount }) => (
	<div className={styles.banner}>
		<CheckCircle2 size={44} strokeWidth={1.5} className={styles.icon} />
		<p className={styles.title}>¡Todo en orden!</p>
		<p className={styles.subtitle}>Los {foundCount} inventarios escaneados coinciden con el inventario esperado.</p>
	</div>
);

export default InventoryTakingBalancedBanner;
